
export class Logger {

  static log = console.log;
  static debug = console.log;
  static error = console.error;
  static warn = console.warn;

}
